<template>
    <div class="h-[100%]">
        <p class="text-gray-50 py-3">Select your route starting from Pfennigparade</p>
        <div class="flex">
            <span class="text-turquoise py-3 pr-3">Destination: </span>
            <span class="w-[18%]">
                <input type="search" list="my-list-id" id="startpt" class="bg-gray-50 border-2 border-turquoise text-gray-900 text-sm rounded-lg p-2.5 w-full" 
                placeholder="Choose a destination" v-model="startpt" @change="emitEventChanged">  
                <datalist id="my-list-id">
                    <option v-for="(starting, index) in destinations" v-bind:key="index.id">{{ starting }}</option>
                </datalist>
            </span>
            <span v-tippy="{
                content: 'Choose a destination to see the shortest accessible route from Stifung Pfennigparade. Move over a destination in the map to obtain more information.', 
                placement: 'right-end'
                }" > 
                <img src="./../assets/info_icon.svg" class="self-center w-8 h-8 rounded-full mx-1" /> 
            </span>
        </div>
        <!-- <span>Destination:</span>
        <input list="my-list-id" id="endpt" placeholder="Destination" v-model="endpt" @change="emitEventChangedDestination">
        <datalist id="my-list-id">
            <option v-for="(ending, index) in starts" v-bind:key="index.id">{{ ending }}</option>
        </datalist> -->
        <!-- <p>endpt {{ endpt }}</p> -->
         <!-- <input v-model="endpt" placeholder="Destination"> -->
    </div>
</template>
  
<script>

    import { TippyDirective} from 'tippy.vue'

    export default {
        name: "navigationMessage",
        // components: {
        //     Tippy
        // },
        directives: {
            tippy: TippyDirective
        },
        data() {
            return{
                startpt: this.startpt,
                endpt: this.endpt,
                starts: [
                    'Pfennigparade'
                ],
                destinations: [
                    'Bei Ling Chinese Restaurant',
                    'BMW Museum',
                    'Burgerhouse 3 Biergarten',
                    'Commerzbank',
                    'Deutsche Bundesbank',
                    'Deutsche Post',
                    'Hans im Glück',
                    'Luitpoldpark',
                    'Marta Trattoria & Bar',
                    'Milbertshofen U-Bahn Station', 
                    'Olympiapark',
                    'Olympiazentrum U-Bahn Station',
                    'Petuelpark',
                    'Petuelring U-Bahn Station',
                    'Rabiang Thai Restaurant',
                    'Rewe',
                    'Scheidplatz U-Bahn Station', 
                    'Stadtsparkasse',
                    'St. Mauritius Apotheke',
                ],

            }
        },
        // props: ['startpt'],
        methods: {
            emitEventChanged () {
                this.$emit('update', this.startpt);
                console.log(`change event: ${this.startpt}`)
            },
            emitEventChangedDestination () {
                this.$emit('updateEnd', this.endpt);
                console.log(`change end event: ${this.endpt}`)
            }
        }
    };
</script>
